import type { ActurisContactDetails } from 'api/quote-marketplace';

export const getSecondaryPhone = (
  contact: Pick<ActurisContactDetails, 'mobile_phone' | 'home_phone'>,
): string => {
  return contact.mobile_phone || contact.home_phone;
};
